import React, { FC, PropsWithChildren } from 'react';
import { Box, Button, Icon, Tooltip } from '@fullstory/components';
import { intl } from '@fullstory/intl';

export interface AdvancedOptionsLinkProps {
  onClick: () => void;
  'data-component': string;
  testId?: string;
}

/** Link that launches modal to configure "advanced options" */
export const AdvancedOptionsLink: FC<PropsWithChildren<AdvancedOptionsLinkProps>> = ({
  onClick,
  testId,
  children,
  ...props
}) => {
  const buttonText = intl.formatMessage({ defaultMessage: 'Advanced options', id: '0cEOKu' });
  return (
    <Box data-component={props['data-component']} inline testId={testId}>
      <Tooltip
        tooltipContent={buttonText}
        placement="bottom"
        compact
        showDelay={300}
        persistDelay={0}
        offset={16}
        interactive={false}
      >
        <Button
          variant="fill-builder"
          onClick={onClick}
          style={{ padding: '0 8px' }}
          testId={testId ? `${testId}-button` : undefined}
        >
          <Icon name="ellipsis-horizontal" size={20} color="secondary" />
        </Button>
      </Tooltip>
      {children}
    </Box>
  );
};
